import { render, staticRenderFns } from "./menuApps.vue?vue&type=template&id=68f5de29&scoped=true"
import script from "./menuApps.vue?vue&type=script&lang=js"
export * from "./menuApps.vue?vue&type=script&lang=js"
import style0 from "./menuApps.vue?vue&type=style&index=0&id=68f5de29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5de29",
  null
  
)

export default component.exports